import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import allActionCreators from 'actionCreators';
import * as selectors from 'selectors';

const actionCreatorRegex = /.+Actions$/;
const selectorRegex = /.+Selectors$/;

/**
 * Bind Redux state and selectors to the props.
 * @param propNames
 * @returns {{}}
 */
function getPropNamesFromState(propNames) {
  return (state, ownProps) => {
    const props = {};

    propNames.forEach(prop => {
      if (actionCreatorRegex.test(prop)) return;
      // If it's a selector, then bind all keys from the selector to the props
      if (selectorRegex.test(prop)) {
        const selector = selectors[prop];
        if (!selector) return;
        Object.keys(selector).map(key => {
          props[key] = selector[key](state, ownProps);
        });
        return;
      }
      props[prop] = state.get(prop);
    });

    return props;
  };
}

function getPropNamesWithDispatch(propNames, dispatch) {
  const boundActionCreators = {};

  propNames.forEach(prop => {
    if (!actionCreatorRegex.test(prop)) return;

    boundActionCreators[prop] = bindActionCreators(
      allActionCreators[prop],
      dispatch
    );
  });

  return boundActionCreators;
}

export const getProps =
  (...propNames) =>
  (Component, includeRouter = true) => {
    const connectedComponent = connect(
      getPropNamesFromState(propNames),
      getPropNamesWithDispatch.bind(null, propNames)
    )(Component);

    if (!includeRouter) return connectedComponent;
    return withRouter(connectedComponent);
  };

export default getProps;

export const exists = true;
